// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_TxB","cls2":"LoggedOutDiscoveryPage-cls2_yz4 LoggedOutDiscoveryPage-cls1_TxB"};